import React, { Component } from "react";
import { apiFetch } from "../utils";
import CreditManager from "../components/Admin/CreditManager";
import PackageManager from "../components/Admin/PackageManager";
import ChatbotManager from "../components/Admin/ChatbotManager";

export default class Admin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "packages", // "config" | "credits"
            expanded_files: {},   // { filename: true/false }
            showModal: false,
            pendingChanges: [],
        };

        // snapshot of the original data for change detection
        this.originalData = null;
    }

    // small deep-clone helper
    deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    componentDidMount() {
        //apiFetch("/api/project/config/base")
        //    .then((res) => res.json())
        //    .then((data) => {
        //        if (Array.isArray(data)) {
        //            // ensure bEnabled exists
        //            const initialized = data?.map((f) => ({
        //                ...f,
        //                bEnabled: f.bEnabled ?? true,
        //                entries: f.entries ?? [],
        //            }));

        //            // store live state and original snapshot
        //            this.setState({ feat_configfiles: initialized });

        //            // keep an immutable original snapshot for comparisons
        //            this.originalData = this.deepClone(initialized);
        //        } else {
        //            console.error("Unexpected data format", data);
        //        }
        //    })
        //    .catch((err) => console.error("Failed to load config files", err));
    }

    handleEntryChange = (fileName, keyName, field, value) => {
        this.setState((prevState) => ({
            feat_configfiles: prevState.feat_configfiles?.map((file) => {
                if (file.name !== fileName) return file;

                const updatedEntries = file.entries?.map((entry) =>
                    entry.keyName === keyName ? { ...entry, [field]: value } : entry
                );

                return { ...file, entries: updatedEntries };
            }),
        }));
    };

    handleFileEnabledChange = (fileName, enabled) => {
        this.setState((prevState) => ({
            feat_configfiles: prevState.feat_configfiles?.map((file) =>
                file.name === fileName ? { ...file, bEnabled: enabled } : file
            ),
        }));
    };

    toggleExpand = (filename) => {
        this.setState((prevState) => ({
            expanded_files: {
                ...prevState.expanded_files,
                [filename]: !prevState.expanded_files[filename],
            },
        }));
    };

    // build changes by comparing current state with this.originalData
    handleSaveChanges = () => {
        const { feat_configfiles } = this.state;
        const original = this.originalData;
        const changes = [];

        if (!original) {
            // safety: if snapshot missing, treat everything as changed
            feat_configfiles.forEach((file) => {
                changes.push({
                    file: file.name,
                    key: "<FILE_ENABLED>",
                    oldValue: null,
                    newValue: file.bEnabled,
                });
                file.entries.forEach((entry) =>
                    changes.push({
                        file: file.name,
                        key: entry.keyName,
                        oldValue: null,
                        newValue: entry.value,
                        oldEnabled: null,
                        newEnabled: entry.bEnabled,
                    })
                );
            });
        } else {
            feat_configfiles.forEach((file) => {
                const origFile = original.find((f) => f.name === file.name);
                // file-level enabled change
                if (origFile) {
                    const origEnabled = !!origFile.bEnabled;
                    const curEnabled = !!file.bEnabled;
                    if (origEnabled !== curEnabled) {
                        changes.push({
                            file: file.name,
                            key: "<FILE_ENABLED>",
                            oldValue: origEnabled,
                            newValue: curEnabled,
                        });
                    }
                } else {
                    // new file (unlikely) => mark file enabled change and all entries
                    changes.push({
                        file: file.name,
                        key: "<FILE_ADDED>",
                        oldValue: null,
                        newValue: file.bEnabled,
                    });
                }

                // entries comparison
                (file.entries || []).forEach((entry) => {
                    const origEntry = origFile?.entries?.find((e) => e.keyName === entry.keyName);
                    const origVal = origEntry ? String(origEntry.value ?? "") : null;
                    const curVal = String(entry.value ?? "");
                    const valueChanged = origVal !== curVal;

                    const origB = origEntry ? !!origEntry.bEnabled : null;
                    const curB = !!entry.bEnabled;
                    const enabledChanged = origB !== curB;

                    if (valueChanged || enabledChanged || !origEntry) {
                        changes.push({
                            file: file.name,
                            key: entry.keyName,
                            oldValue: origEntry ? origEntry.value : null,
                            newValue: entry.value,
                            oldEnabled: origEntry ? origEntry.bEnabled : null,
                            newEnabled: entry.bEnabled,
                        });
                    }
                });
            });
        }

        this.setState({ showModal: true, pendingChanges: changes });
    };

    // confirm: send only modified entries grouped by file to endpoint
    confirmSave = async () => {
        const { feat_configfiles, pendingChanges } = this.state;

        if (!pendingChanges || pendingChanges?.length === 0) {
            alert("No changes to save.");
            this.setState({ showModal: false });
            return;
        }

        // ✅ Send the full current state, not just changes
        // so backend can overwrite or upsert completely
        const payload = feat_configfiles?.map((file) => ({
            bEnabled: !!file.bEnabled,
            name: file.name,
            path: file.path || "",
            entries: (file.entries || [])?.map((entry) => ({
                bEnabled: !!entry.bEnabled,
                keyName: entry.keyName,
                value: entry.value,
                notes: entry.notes || "",
            })),
        }));

        try {
            const res = await apiFetch("/api/project/config/base", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
                idempotencyAction:"config:base:set"
            });

            // apiFetch may return the raw fetch Response or parsed json depending on your util;
            // handle both cases gracefully:
            let ok = false;
            try {
                if (res && typeof res.ok === "boolean") ok = res.ok;
                else ok = true; // assume success if apiFetch returned parsed data
            } catch {
                ok = true;
            }

            if (ok) {
                alert("Changes saved successfully!");
                // update snapshot so subsequent changes are detected correctly
                this.originalData = this.deepClone(feat_configfiles);
            } else {
                alert("Failed to save changes. See console for details.");
            }
        } catch (err) {
            console.error("Failed to save changes:", err);
            alert("Error saving changes. See console for details.");
        } finally {
            this.setState({ showModal: false, pendingChanges: [] });
        }
    };

    cancelSave = () => {
        this.setState({ showModal: false, pendingChanges: [] });
    };

    renderConfigFileKeys = (file) => {
        const disabled = !file.bEnabled;
        if (!file.entries || file.entries?.length === 0)
            return <p className="ms-3 text-muted">No entries found.</p>;

        return (
            <div className={`ms-3 mt-2 ${disabled ? "opacity-50" : ""}`}>
                {file.entries?.map((entry) => (
                    <div key={entry.keyName} className="mb-3">
                        {entry.notes && (
                            <div className="text-muted small mb-1">{entry.notes}</div>
                        )}

                        <div className="row align-items-center g-2">
                            <div className="col-auto">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={!!entry.bEnabled}
                                    disabled={disabled}
                                    onChange={(e) =>
                                        this.handleEntryChange(
                                            file.name,
                                            entry.keyName,
                                            "bEnabled",
                                            e.target.checked
                                        )
                                    }
                                />
                            </div>

                            <div className="col-4 col-sm-5">
                                <label className="form-check-label fw-bold">
                                    {entry.keyName}
                                </label>
                            </div>

                            <div className="col">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={entry.value ?? ""}
                                    disabled={disabled}
                                    onChange={(e) =>
                                        this.handleEntryChange(
                                            file.name,
                                            entry.keyName,
                                            "value",
                                            e.target.value
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    render() {
        const { feat_configfiles, expanded_files, showModal, pendingChanges, activeTab } = this.state;

        return (
            <div className="hk-page">
                <header className="hk-page-head">
                    <div>
                        <div className="hk-eyebrow">Platform</div>
                        <h1 className="hk-page-title">Admin Panel</h1>
                        <div className="hk-page-sub">Packages · credits · chatbot tenants</div>
                    </div>
                </header>

                {/* Tab navigation */}
                <div className="flex gap-2 mb-4 flex-wrap">
                    {[
                        ["packages", "📦 Packages"],
                        ["credits", "💳 Credits"],
                        ["chatbotTenants", "🤖 Chatbot Tenants"],
                    ].map(([key, label]) => (
                        <button
                            key={key}
                            className={`hk-btn hk-btn-sm ${activeTab === key ? "hk-btn-dark" : "hk-btn-outline"}`}
                            onClick={() => this.setState({ activeTab: key })}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {/* Config Tab */}
                {/*{activeTab === "config" && (*/}
                {/*    <div>*/}
                {/*{feat_configfiles?.length === 0 ? (*/}
                {/*    <p>Loading configuration files...</p>*/}
                {/*) : (*/}
                {/*    <div className="card p-3">*/}
                {/*        {feat_configfiles?.map((file) => (*/}
                {/*            <div*/}
                {/*                key={file.name}*/}
                {/*                className={`border rounded p-2 mb-2 ${!file.bEnabled ? "opacity-75" : ""}`}*/}
                {/*            >*/}
                {/*                <div className="d-flex justify-content-between align-items-center">*/}
                {/*                    <div*/}
                {/*                        className="d-flex align-items-center"*/}
                {/*                        style={{ gap: "0.5rem", cursor: "pointer" }}*/}
                {/*                        onClick={() => this.toggleExpand(file.name)}*/}
                {/*                    >*/}
                {/*                        <span*/}
                {/*                            className={`me-1 ${expanded_files[file.name] ? "fw-bold" : "text-muted"}`}*/}
                {/*                        >*/}
                {/*                            {expanded_files[file.name] ? "▼" : "▶"}*/}
                {/*                        </span>*/}
                {/*                        <strong>{file.name}</strong>*/}
                {/*                    </div>*/}

                {/*                    <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>*/}
                {/*                        <input*/}
                {/*                            type="checkbox"*/}
                {/*                            checked={!!file.bEnabled}*/}
                {/*                            onChange={(e) => this.handleFileEnabledChange(file.name, e.target.checked)}*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*                </div>*/}

                {/*                {expanded_files[file.name] && this.renderConfigFileKeys(file)}*/}
                {/*            </div>*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*)}*/}

                {/*<button className="btn btn-primary mt-3" onClick={this.handleSaveChanges}>*/}
                {/*    Save Changes*/}
                {/*</button>*/}
                {/*    </div>*/}
                {/*)}*/}

                {/* Credit Tab */}
                {activeTab === "credits" && (
                    <CreditManager />
                )}

                {activeTab === "packages" && (
                    <PackageManager/>
                )}

                {activeTab === "chatbotTenants" && (
                    <ChatbotManager/>
                )}

                {/* Confirmation Modal */}
                {showModal && (
                    <div className="modal show" style={{ display: "block", backgroundColor: "rgba(9,9,11,0.55)" }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content" style={{ borderRadius: 20, border: "none" }}>
                                <div className="modal-header" style={{ borderBottom: "1px solid var(--hk-border)" }}>
                                    <h5 className="modal-title font-black tracking-tight">Confirm Changes</h5>
                                    <button className="btn-close" onClick={this.cancelSave}></button>
                                </div>
                                <div className="modal-body">
                                    {pendingChanges?.length === 0 ? (
                                        <p>No changes detected.</p>
                                    ) : (
                                        <table className="table table-sm table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>File</th>
                                                    <th>Key</th>
                                                    <th>Old Value</th>
                                                    <th>New Value</th>
                                                    <th>Enabled</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pendingChanges?.map((c, i) => (
                                                    <tr key={i}>
                                                        <td>{c.file}</td>
                                                        <td>{c.key}</td>
                                                        <td>{String(c.oldValue ?? "")}</td>
                                                        <td>{String(c.newValue ?? "")}</td>
                                                        <td>
                                                            {c.newEnabled !== undefined ? (c.newEnabled ? "✅" : "❌") : (c.newValue !== undefined ? (c.newValue ? "✅" : "❌") : "-")}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                                <div className="modal-footer" style={{ borderTop: "1px solid var(--hk-border)" }}>
                                    <button className="hk-btn hk-btn-outline hk-btn-sm" onClick={this.cancelSave}>Cancel</button>
                                    {pendingChanges?.length > 0 && (
                                        <button className="hk-btn hk-btn-primary hk-btn-sm" onClick={() => this.confirmSave()}>Confirm Save</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
